if (!customElements.get('soap-hero-carousel')) {
  customElements.define('soap-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const slides = [...this.querySelectorAll('[data-hero-slide]')];
      if (slides.length < 2) return;
      const controller = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: controller.signal });
      let index = 0, timer, touch;
      let paused = !this.hasAttribute('data-autoplay') || matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pause = this.querySelector('[data-pause]');
      const updatePause = () => {
        if (!pause) return;
        pause.querySelector('[data-play-icon]').hidden = !paused;
        pause.querySelector('[data-pause-icon]').hidden = paused;
        pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (this.isConnected && !paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) {
          timer = setInterval(() => show(index + 1, false), Number(this.dataset.interval) || 5000);
        }
      };
      const show = (next, announce = true) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        this.querySelectorAll('[data-slide-to]').forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const status = this.querySelector('[data-status]');
        status.setAttribute('aria-live', announce ? 'polite' : 'off');
        status.textContent = `${index + 1} / ${slides.length}`;
      };
      const manual = next => { paused = true; stop(); updatePause(); show(next); };
      this.querySelectorAll('[data-slide-to]').forEach(dot => on(dot, 'click', () => manual(Number(dot.dataset.slideTo))));
      on(this.querySelector('[data-prev]'), 'click', () => manual(index - 1));
      on(this.querySelector('[data-next]'), 'click', () => manual(index + 1));
      if (pause) on(pause, 'click', () => { paused = !paused; updatePause(); start(); });
      on(this, 'mouseenter', stop);
      on(this, 'mouseleave', start);
      on(this, 'focusin', stop);
      on(this, 'focusout', () => setTimeout(start, 0));
      on(document, 'visibilitychange', start);
      on(this, 'touchstart', event => { touch = event.touches[0]; stop(); });
      on(this, 'touchend', event => {
        const end = event.changedTouches[0];
        if (touch && Math.abs(end.clientX - touch.clientX) > 50 && Math.abs(end.clientX - touch.clientX) > Math.abs(end.clientY - touch.clientY)) manual(index + (end.clientX < touch.clientX ? 1 : -1));
        touch = null; start();
      });
      on(document, 'shopify:block:select', event => {
        const selected = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (selected >= 0) manual(selected);
      });
      this.querySelector('.hero-carousel-controls').hidden = false;
      updatePause(); start();
      this.cleanup = () => { stop(); controller.abort(); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}
